<template>
    <div class="review-club-overview">
        <UserBox :review="review" />
        <MainBox :review="review" />
        <Modal :modal-name="`ask-question-login-${review.id}`" role="dialog" aria-hidden="true" :title="$t('rating.title')">
            <!-- FIXME redirect -->
            <div class="modal-body">
                <i18n path="rating.login.mustLogin" tag="label" for="rating.login.signIn">
                    <a :href="$t('discussions.loginUrl')" v-html="$t('rating.login.signIn')" />
                </i18n>
            </div>
        </Modal>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Modal from '~/components/Modal.vue'
import Review from '~/models/ReviewClub/Review'
import UserBox from '~/components/objects/ReviewClub/PreviewCard/UserBox.vue'
import MainBox from '~/components/objects/ReviewClub/PreviewCard/MainBox.vue'

export default {
    components: {
        MainBox,
        UserBox,
        Modal,
    },

    props: {
        review: {
            type: Object as PropType<Review>,
            default: () => ({} as Review),
        },
    },
}
</script>

<style lang="scss" scoped>
.review-club-overview {
    display: flex;
    flex-wrap: wrap;
    box-shadow: $box-shadow;
    border-radius: 10px;
    font-size: 14px;
}
</style>
